var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"homelogado"},[_c('Header'),_c('div',{staticClass:"container mt-4"},[_c('Ferramentas',{staticClass:"mt-5"})],1),_c('Footer',{staticClass:"mt-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }